import React from 'react'
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import ShipDetail from '../components/ShipDetail';

const ShipdetailsPage = () => {
  return (
    <div>
      
      <ShipDetail/>
      <Footer/>
    </div>
  )
}

export default ShipdetailsPage;
